import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ImportarArquivoRequest } from '../../requests/pessoa/importar-arquivo.request';
import { ValidacaoImportacaoResponse } from '../../responses/pessoa/validacao-importacao.response';
import { ItemValidacaoStruct } from '../../structs/pessoa/item-validacao.struct';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({ providedIn: 'root' })
export class ImportarPessoaService extends CommonService {
  private readonly apiUrl = `${environment.urlApiOrquestradorPessoa}ImportarPessoa`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public validar(request: ImportarArquivoRequest): Observable<ValidacaoImportacaoResponse> {
    return this.httpClient
      .post<ValidacaoImportacaoResponse>(`${this.apiUrl}/validar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public confirmar(itens: ItemValidacaoStruct[]): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/confirmar`, itens, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
